import { useSelector } from 'react-redux';

export default function useFindMinMaxSeries(firstSeries, secondSeries) {
  const comparedGraph = Object.keys(useSelector(({ globalDomain }) => globalDomain.filters.locked)).length !== 0;

  const minMax = {
    mapOne: { max: null, min: null },
    mapTwo: { max: null, min: null },
  };

  const regroupAndSumData = (data) => {
    const result = [];
    data.forEach((element) => {
      result.push(element.data);
    });

    // Sum positive values
    const sum = result.reduce((a, b) =>
      a?.map((c, i) => {
        if (c >= 0 && b[i] >= 0) {
          return c + b[i];
        } else if (c <= 0 && b[i] <= 0) {
          return 0;
        } else if (c >= 0 && b[i] <= 0) {
          return c + 0;
        } else if (c <= 0 && b[i] >= 0) {
          return b[i] + 0;
        } else {
          return 0;
        }
      }),
    );

    // Sum negative values
    const sumT = result.reduce((a, b) =>
      a?.map((c, i) => {
        if (c >= 0 && b[i] >= 0) {
          return 0;
        } else if (c <= 0 && b[i] <= 0) {
          return c + b[i];
        } else if (c >= 0 && b[i] <= 0) {
          return 0 + b[i];
        } else if (c <= 0 && b[i] >= 0) {
          return c + 0;
        } else {
          return 0;
        }
      }),
    );

    const round = (number) => {
      if (number > 0) {
        return Math.ceil(number);
      } else {
        return Math.floor(number);
      }
    };

    const max = round(Math.max(...sum));
    const min = round(Math.min(...sumT));

    return { max, min };
  };

  const calculateMinMax = (currentSerie, lockedSerie) => {
    const max = Math.max(...[regroupAndSumData(currentSerie).max, regroupAndSumData(lockedSerie).max]);
    const min = Math.min(...[regroupAndSumData(currentSerie).min, regroupAndSumData(lockedSerie).min]);

    return { min, max };
  };

  if (comparedGraph) {
    if (firstSeries?.generalSerie?.length > 0 && firstSeries?.lockedSerie?.length > 0) {
      const result = calculateMinMax(firstSeries.generalSerie, firstSeries.lockedSerie);
      minMax.mapOne.max = result.max;
      minMax.mapOne.min = result.min;
    }

    if (secondSeries?.generalSerie?.length > 0 && secondSeries?.lockedSerie?.length > 0) {
      const result = calculateMinMax(secondSeries.generalSerie, secondSeries.lockedSerie);
      minMax.mapTwo.max = result.max;
      minMax.mapTwo.min = result.min;
    }
  }

  return minMax;
}
